/**
 * @file rateLimitConstants.ts
 * @description Browser-safe rate-limit constants. Extracted from rateLimiter.ts on 2026-05-14
 *              so that client components can import without dragging Node-only modules
 *              (fs, node:path, node:crypto) into the browser bundle.
 * @rule No Node-only imports in this file (no fs, path, crypto, dotenv, etc.).
 *       Any future constant that needs Node APIs MUST stay in rateLimiter.ts,
 *       not be added here. Violating this rule breaks the client build.
 * @rule This file MUST stay tiny — constants only, no functions, no classes,
 *       no derived values that perform any computation more elaborate than
 *       an arithmetic literal. Behavior belongs in rateLimiter.ts.
 */

// Limit reduced 2026-05-10 from 3 to 2 (series batch-2026-05-10-rate-limit-gate-fix
// prompt 04). Funnel data: 0.27% widget→bot conversion at limit=3 — users were
// hitting the wall too late, after evaluating the tool, when motivation peaked
// but already-satisfied curiosity. Limit=2 brings the gate one step earlier
// (after the user has seen one full result, before fatigue sets in).
export const MAX_ANONYMOUS_REQUESTS = 2;
